export class AwsRestoreAccountAttributesInput {
    'roleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
